/**
 * El intervalo del panel, al lado de «En vivo».  (054 · FR-001)
 *
 * Una elección para Resumen y Calendario. No sondea el resto.
 */
import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import { CLAVES_REFRESCO, INTERVALOS_REFRESCO } from '../lib/calendario-refresco'
import { useRefrescoCalendario } from '../lib/use-refresco-calendario'

export function RefrescoCabecera() {
    const qc = useQueryClient()
    const recargar = useCallback(() => {
        for (const queryKey of CLAVES_REFRESCO) {
            void qc.invalidateQueries({ queryKey: [...queryKey] })
        }
    }, [qc])
    const { intervaloMs, elegir } = useRefrescoCalendario(recargar)

    return (
        <label className="flex items-center gap-1.5 text-xs text-neutral-500">
            <span className="hidden sm:inline">cada</span>
            <select
                aria-label="Cada cuánto se actualiza el panel"
                data-testid="refresco-panel"
                value={intervaloMs}
                onChange={(e) => elegir(Number(e.target.value))}
                className="rounded-md border border-neutral-800 bg-neutral-950 px-1.5 py-1 text-neutral-200"
            >
                {INTERVALOS_REFRESCO.map((i) => (
                    <option key={i.ms} value={i.ms}>
                        {i.etiqueta}
                    </option>
                ))}
            </select>
        </label>
    )
}
